import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { BUSINESS_FLOW, IMAGES } from "@/lib/content";
import { ArrowRight } from "lucide-react";

const REVENUE = [
  "Fish sales", "Breeding", "YouTube", "Affiliate income",
  "Manufacturer partnerships", "Product testing", "Aquarium products", "Online sales",
];

export const BusinessSection = () => {
  return (
    <section className="py-24 lg:py-32 relative overflow-hidden" data-testid="business-section">
      <div className="absolute inset-0 opacity-[0.12]">
        <img src={IMAGES.fishFocus} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-brand-base/80" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <SectionLabel>The Business Journey</SectionLabel>
          <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            CAN THIS ACTUALLY BECOME A BUSINESS?
          </h2>
          <p className="mt-5 text-brand-textSec leading-relaxed">
            The goal isn't simply to create a YouTube channel. The long-term goal is to discover whether a
            tropical fish hobby can become a sustainable business.
          </p>
        </Reveal>

        {/* business flow */}
        <Reveal delay={0.1}>
          <div className="mt-14 flex flex-wrap items-center gap-x-2 gap-y-4">
            {BUSINESS_FLOW.map((step, i) => (
              <div key={step} className="flex items-center gap-2">
                <span
                  className={`font-display font-bold text-sm sm:text-base px-4 py-2.5 rounded-full border ${
                    i === 0
                      ? "border-brand-cyan/50 text-brand-cyan bg-brand-cyan/10"
                      : i === BUSINESS_FLOW.length - 1
                      ? "border-brand-cyan text-brand-base bg-brand-cyan"
                      : "border-white/10 text-white bg-brand-surface"
                  }`}
                >
                  {step.toUpperCase()}
                </span>
                {i < BUSINESS_FLOW.length - 1 && <ArrowRight size={16} className="text-brand-textMuted" />}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-14 card-surface p-8 sm:p-10">
            <h3 className="font-display font-semibold text-white text-lg">Potential future revenue streams</h3>
            <p className="text-brand-textSec text-sm mt-1">
              These are possibilities to explore — not claims of current revenue.
            </p>
            <div className="mt-6 flex flex-wrap gap-2.5">
              {REVENUE.map((r) => (
                <span key={r} className="text-sm text-brand-textSec border border-white/10 rounded-full px-4 py-2">
                  {r}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
